module.exports = __webpack_public_path__ + "img/Piggy.506e8175.png";